/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.portals.platform.app.rpc.AvatarsRpc
 */

export const getAvatarsBulkRpc = {
  serviceName: 'com.hubspot.portals.platform.app.rpc.AvatarsRpc',
  rpcName: 'getAvatarsBulk',
  auth: 'external',
  fingerprint: 'QnznfeWK6io9cy83yY-GQL5doOheSwTZ',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};